import { FieldBase } from '../field/field-base'

export abstract class AntFieldBase<T> extends FieldBase<any> {
  isHorizontal?: boolean
  constructor(options: FieldBase<any> & { isHorizontal?: boolean }) {
    super(options)
    this.isHorizontal = options.isHorizontal == undefined ? true : options.isHorizontal
  }
}
